module.exports = __webpack_public_path__ + "static/media/Marotte_Lati_MT100-19-Scale.32c35076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Lati_MT100-19-Scale.jpg
// module id = 956
// module chunks = 37